interface FinalCTAProps {
  onOpenWaitlist: () => void;
}

export default function FinalCTA({ onOpenWaitlist }: FinalCTAProps) {
  return (
    <section className="py-12 sm:py-16 lg:py-24 bg-[#35C5F0] relative overflow-hidden">
      {/* Background pattern */}
      <div className="absolute inset-0 opacity-10">
        <div className="absolute inset-0" style={{
          backgroundImage: 'radial-gradient(circle at 2px 2px, white 1px, transparent 0)',
          backgroundSize: '40px 40px'
        }}></div>
      </div>

      {/* Gradient orbs */}
      <div className="absolute top-0 left-1/4 w-48 sm:w-72 lg:w-96 h-48 sm:h-72 lg:h-96 bg-white/10 rounded-full blur-3xl"></div>
      <div className="absolute bottom-0 right-1/4 w-48 sm:w-72 lg:w-96 h-48 sm:h-72 lg:h-96 bg-[#2F3438]/10 rounded-full blur-3xl"></div>

      <div className="max-w-5xl mx-auto px-4 sm:px-6 text-center relative z-10">
        {/* Designer Avatars */}
        <div className="flex justify-center mb-6 sm:mb-8">
          <div className="flex -space-x-3 sm:-space-x-4">
            <img
              src="https://public.readdy.ai/ai/img_res/87de580f1bcc1b64c07749e4279edc4c.jpg"
              alt="Designer"
              className="w-10 h-10 sm:w-12 sm:h-12 lg:w-14 lg:h-14 rounded-full border-3 sm:border-4 border-[#35C5F0] object-cover"
            />
            <img
              src="https://readdy.ai/api/search-image?query=professional%20indian%20man%20architect%20beard%20confident%20smile%20headshot%20portrait%20clean%20white%20background%20studio%20lighting%20formal&width=60&height=60&seq=final-cta-avatar-man-2&orientation=squarish"
              alt="Designer"
              className="w-10 h-10 sm:w-12 sm:h-12 lg:w-14 lg:h-14 rounded-full border-3 sm:border-4 border-[#35C5F0] object-cover"
            />
            <img
              src="https://readdy.ai/api/search-image?query=professional%20indian%20woman%20architect%20glasses%20confident%20smile%20headshot%20portrait%20clean%20white%20background%20studio%20lighting%20modern&width=60&height=60&seq=final-cta-avatar-woman-3&orientation=squarish"
              alt="Designer"
              className="w-10 h-10 sm:w-12 sm:h-12 lg:w-14 lg:h-14 rounded-full border-3 sm:border-4 border-[#35C5F0] object-cover"
            />
            <img
              src="https://readdy.ai/api/search-image?query=professional%20young%20indian%20man%20interior%20designer%20stylish%20confident%20smile%20headshot%20portrait%20clean%20white%20background%20studio%20lighting%20casual&width=60&height=60&seq=final-cta-avatar-man-4&orientation=squarish"
              alt="Designer"
              className="w-10 h-10 sm:w-12 sm:h-12 lg:w-14 lg:h-14 rounded-full border-3 sm:border-4 border-[#35C5F0] object-cover"
            />
            <img
              src="https://readdy.ai/api/search-image?query=professional%20indian%20woman%20construction%20manager%20confident%20smile%20headshot%20portrait%20clean%20white%20background%20studio%20lighting%20professional%20attire&width=60&height=60&seq=final-cta-avatar-woman-5&orientation=squarish"
              alt="Designer"
              className="w-10 h-10 sm:w-12 sm:h-12 lg:w-14 lg:h-14 rounded-full border-3 sm:border-4 border-[#35C5F0] object-cover"
            />
            <img
              src="https://readdy.ai/api/search-image?query=professional%20senior%20indian%20man%20architect%20experienced%20confident%20smile%20headshot%20portrait%20clean%20white%20background%20studio%20lighting%20distinguished&width=60&height=60&seq=final-cta-avatar-man-6&orientation=squarish"
              alt="Designer"
              className="w-10 h-10 sm:w-12 sm:h-12 lg:w-14 lg:h-14 rounded-full border-3 sm:border-4 border-[#35C5F0] object-cover"
            />
          </div>
        </div>

        <div className="inline-block px-3 sm:px-4 py-2 bg-white/20 border border-white/30 rounded-full text-white text-xs sm:text-sm font-semibold mb-6 sm:mb-8">
          Join 2K+ Designers
        </div>

        <h2 className="text-3xl sm:text-4xl lg:text-5xl xl:text-6xl font-bold text-white mb-4 sm:mb-6 leading-tight">
          Stop Being Invisible.<br className="hidden sm:block" /><span className="sm:hidden"> </span>Start Being Iconic.
        </h2>

        <p className="text-base sm:text-lg lg:text-xl text-white/80 mb-8 sm:mb-12 max-w-3xl mx-auto leading-relaxed px-4">
          Create your professional portfolio in 10 minutes. Sync all your platforms. Get more clients. All for free, forever.
        </p>

        {/* CTA Button */}
        <button 
          onClick={onOpenWaitlist}
          className="px-8 sm:px-10 lg:px-12 py-4 sm:py-5 bg-[#2F3438] text-white rounded-xl font-bold text-base sm:text-lg lg:text-xl hover:bg-[#2F3438]/90 transition-all shadow-2xl shadow-[#2F3438]/30 hover:scale-105 cursor-pointer whitespace-nowrap inline-block mb-3"
        >
          Get Your Free Forever Link
        </button>

        {/* No Credit Card Required - Below Button */}
        <div className="text-white/90 text-sm sm:text-base mb-6">
          No Credit Card Required
        </div>

        {/* Trust Indicators */}
        <div className="flex flex-col sm:flex-row items-center justify-center gap-3 sm:gap-6 text-white/90 text-sm sm:text-base">
          <div className="flex items-center gap-2">
            <i className="ri-check-line text-white"></i>
            <span>Free Forever</span>
          </div>
          <div className="flex items-center gap-2">
            <i className="ri-check-line text-white"></i>
            <span>Setup in 10 minutes</span>
          </div>
        </div>
      </div>
    </section>
  );
}
